import * as ambassadorWixEcomV1CheckoutSettings from './ecom-v1-checkout-settings-checkout-settings.http.js';
import * as ambassadorWixEcomV1CheckoutSettingsTypes from './ecom-v1-checkout-settings-checkout-settings.types.js';
import * as ambassadorWixEcomV1CheckoutSettingsUniversalTypes from './ecom-v1-checkout-settings-checkout-settings.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getCheckoutSettings(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixEcomV1CheckoutSettingsUniversalTypes.GetCheckoutSettingsRequest,
  ambassadorWixEcomV1CheckoutSettingsTypes.GetCheckoutSettingsRequest,
  ambassadorWixEcomV1CheckoutSettingsUniversalTypes.GetCheckoutSettingsResponse &
    ambassadorWixEcomV1CheckoutSettingsUniversalTypes.GetCheckoutSettingsResponseNonNullableFields,
  ambassadorWixEcomV1CheckoutSettingsTypes.GetCheckoutSettingsResponse &
    ambassadorWixEcomV1CheckoutSettingsTypes.GetCheckoutSettingsResponseNonNullableFields
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1CheckoutSettings.getCheckoutSettings(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/checkout-settings',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateCheckoutSettings(): __PublicMethodMetaInfo<
  'PATCH',
  {},
  ambassadorWixEcomV1CheckoutSettingsUniversalTypes.UpdateCheckoutSettingsRequest,
  ambassadorWixEcomV1CheckoutSettingsTypes.UpdateCheckoutSettingsRequest,
  ambassadorWixEcomV1CheckoutSettingsUniversalTypes.UpdateCheckoutSettingsResponse &
    ambassadorWixEcomV1CheckoutSettingsUniversalTypes.UpdateCheckoutSettingsResponseNonNullableFields,
  ambassadorWixEcomV1CheckoutSettingsTypes.UpdateCheckoutSettingsResponse &
    ambassadorWixEcomV1CheckoutSettingsTypes.UpdateCheckoutSettingsResponseNonNullableFields
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1CheckoutSettings.updateCheckoutSettings(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/checkout-settings',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}
